export const SupportTypeEnum = {
  CREATOR: 'CREATOR',
  CONSUMER: 'CONSUMER',
};
